"use client";

import { useContext, type CSSProperties } from "react";

import { cn } from "@/lib/utils";
import { DividerBlock as DividerBlockType } from "@/lib/utils/lomdaV3/types";
import { useBlockEditable } from "../../../hooks/useBlockEditable";
import { SlotDepthContext } from "../../../hooks/useBlockDnd";
import {
    useResolvedBlockGap,
    useResolvedInnerGap,
} from "../../../hooks/useGridGap";
import {
    DIVIDER_CONFIG,
    resolveDividerAppearance,
} from "../../../lib/blockRegistry";
import { NESTED_FRAME_PADDING_PX, NESTED_GAP_PX } from "../../../lib/constants";
import "./dividerBlock.css";

export default function DividerBlock({ block }: { block: DividerBlockType }) {
    const editable = useBlockEditable();
    const innerGap = useResolvedInnerGap();
    const blockGap = useResolvedBlockGap();
    const nested = useContext(SlotDepthContext) > 0;
    const { thickness, spacing, color } = resolveDividerAppearance(
        block.data?.appearance
    );
    const hitRoom = nested
        ? NESTED_FRAME_PADDING_PX + NESTED_GAP_PX / 2
        : blockGap / 2;

    return (
        <div
            className="relative"
            style={{
                paddingBlock: innerGap * DIVIDER_CONFIG.spacingScale[spacing],
            }}
        >
            <hr
                className={cn(
                    "rounded-[var(--radius)]",
                    DIVIDER_CONFIG.thicknessClass[thickness]
                )}
                style={{ borderColor: color ?? DIVIDER_CONFIG.themeColor }}
            />
            {editable && (
                <span
                    aria-hidden
                    className="lomda-v3-divider-hit"
                    style={
                        {
                            "--divider-hit-room": `${hitRoom}px`,
                        } as CSSProperties
                    }
                />
            )}
        </div>
    );
}
